import { useEffect } from "react";
import { useQuery } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { Veiculo } from "../../../../services/Veiculo";

export const useVeiculoPorId = (uuid: string) => {
  const query = useQuery({
    queryKey: ["veiculo-por-id", uuid],
    queryFn: () => Veiculo.byId({ uuid }),
    select: (response) => response.data,
    enabled: !!uuid,
  });

  useEffect(() => {
    if (!query.isError) return;

    const {
      response: {
        data: { mensagem },
      },
    } = query.error as any;

    toast.error(mensagem);
  }, [query.isError]);

  return query;
};
